import { MockMethod } from 'vite-plugin-mock';

export default [
    {
        url: '/mock/home/carousel/list',
        method: 'post',
        response: (option:any) =>
        {
            return {
                code: 0,
                data: [
                    {
                        title: '',
                        desc: '',
                        url: 'https://oss.zeewain.com/WEBSITE_RESOURCE/a8c1cb609e3d4117918babdd3ef4c9a5/%E9%A6%96%E9%A1%B5banner_01.jpg',
                        to: ''
                    },
                    {
                        title: '',
                        desc: '',
                        url: 'https://oss.zeewain.com/WEBSITE_RESOURCE/630685c41fdb4be8abec52d4f86f230d/%E9%A6%96%E9%A1%B5banner_03.jpg',
                        to: ''
                    }
                ],
                message: 'success'
            };
        }
    }
] as MockMethod[];
